export const systemConfig = {
  cookiePrefix: '__ARCHIVE__',
  zhSystemLongTimerOut: 1000 *  60 * 60 * 3,  // 系统长时间没操作三个小时后自动弹出登录超时
};




// WEBPACK FOOTER //
// ./src/config/system.js